import { useTranslation } from "@/hooks/useTranslation";
import { useBatchAddProxies } from "@/services";
import { Card, CardContent, Typography } from "@st-marketplace/ui";
import React from "react";
import { ProxyForm } from "./ProxyForm";
import type { ProxyFormData } from "./proxyForm.schema";

const ProxyFormCreate: React.FC = () => {
	const { t } = useTranslation();
	const batchAddProxiesMutation = useBatchAddProxies();

	const initialValues = React.useMemo(
		() => ({
			ip_address: "",
			port: undefined,
			username: null,
			password: null,
		}),
		[],
	);

	const handleSubmit = async (data: ProxyFormData) => {
		await batchAddProxiesMutation.mutateAsync({
			body: {
				proxy_kind: "PERSONAL",
				proxies: [
					{
						ip_address: data.ip_address,
						port: data.port!,
						username: data.username ?? null,
						password: data.password ?? null,
					},
				],
			},
		});
	};

	return (
		<div className="mb-5">
			<Typography variant="title-md" as="h2" className="mb-4">
				{t("proxy.new.formTitle")}
			</Typography>
			<Card>
				<CardContent className="p-[3%]">
					<ProxyForm
						submitLabel={t("proxy.new.formSubmit")}
						initialValues={initialValues}
						loading={batchAddProxiesMutation.isPending}
						onSubmit={handleSubmit}
					/>
				</CardContent>
			</Card>
		</div>
	);
};

export default ProxyFormCreate;
